<template>
    <div class="hpc__container hidden-print" :class="{'hpc__container_opened':opened}">
        <button type="button"
                class="hpc__help-menu-button hpc__help-menu-button_help"
                @click="helpClick"
                :aria-expanded="opened ? 'true' : 'false'"
                aria-controls="hpc-help-menu-content"
                aria-label="Help Menu">
            <div class="hpc__help-icon_lifesaver hpc__help-icon"></div>
            <svg class="hpc__mobile-icon" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"/>
                <circle cx="12" cy="12" r="4"/>
                <path d="M4.93 4.93l4.24 4.24M14.83 9.17l4.24-4.24M14.83 14.83l4.24 4.24M9.17 14.83l-4.24 4.24"/>
            </svg>
            <div class="hpc__help-icon-text">{{ opened ? 'Close' : 'Help' }}<span class="hpc__help-icon-text-more"><br/>Menu</span></div>
        </button>
        <a class="hpc__help-menu-button hpc__help-menu-button_ah"
           v-if="isAh"
           :href="ahLink"
           @click="followLink($event, ahLink)"
           aria-label="Portal">
            <div class="hpc__help-icon_ah hpc__help-icon"></div>
            <svg class="hpc__mobile-icon" viewBox="0 0 24 24" aria-hidden="true">
                <rect x="9" y="2" width="6" height="6" rx="1"/>
                <path d="M12 8v4M5 12h14M5 12v3M12 12v3M19 12v3"/>
                <circle cx="5" cy="18" r="3"/>
                <circle cx="12" cy="18" r="3"/>
                <circle cx="19" cy="18" r="3"/>
            </svg>
            <div class="hpc__help-icon-text">Portal</div>
        </a>
        <a class="hpc__help-menu-button hpc__help-menu-button_rba"
           v-if="isRbaScopeAdmin&&!isAh"
           :href="rbaLink"
           @click="followLink($event, rbaLink)"
           aria-label="RBA Tables">
            <div class="hpc__help-icon_rba hpc__help-icon"></div>
            <svg class="hpc__mobile-icon" viewBox="0 0 24 24" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <path d="M3 9h18M3 15h18M12 3v18"/>
            </svg>
            <div class="hpc__help-icon-text">RBA<span class="hpc__help-icon-text-more"><br/>Tables</span></div>
        </a>
        <a class="hpc__help-menu-button hpc__help-menu-button_feedback"
           href="https://www.multime.com/software-feedback"
           target="_blank"
           rel="noopener"
           aria-label="Feedback (opens in a new tab)">
            <div class="hpc__help-icon_feedback hpc__help-icon" aria-hidden="true">
                <i class="fas fa-thumbs-up"></i>
                <i class="fas fa-thumbs-down"></i>
            </div>
            <svg class="hpc__mobile-icon" viewBox="0 0 30 30" aria-hidden="true">
                <g transform="scale(0.65)">
                    <path d="M7 10v12M15 5.88L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>
                </g>
                <g transform="translate(14 14) scale(0.65)">
                    <path d="M17 14V2M9 18.12L10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"/>
                </g>
            </svg>
            <div class="hpc__help-icon-text">Feed<span class="hpc__help-icon-text-more">-<br/></span>back</div>
        </a>
        <div id="hpc-help-menu-content"
             class="vhm-content__container"
             :class="{'vhm-content__container_opened': opened}"
             :aria-hidden="opened ? 'false' : 'true'">
            <help-desk-display :focusable="opened"></help-desk-display>
            <h3 class="vhm-content__header"><a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/home" target="_blank">Explore
                our knowledge base</a></h3>
            <h3 class="vhm-content__header">
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000606757" target="_blank">Getting
                    Started</a>
            </h3>
            <h3 class="vhm-content__header">
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/44000439834" target="_blank">Basic Toolkit
                    Guides</a>
            </h3>
            <ol class="vhm-content__list">
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649720"
                   target="_blank">My Circle</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44001258075"
                   target="_blank">My Wiki</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649724"
                   target="_blank">My Diary</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649723"
                   target="_blank">My {{ $customTerm("Goals") }}</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000685152" target="_blank">My Calendar</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/a/solutions/folders/44000649721"
                   target="_blank">My Media</a></span>
                </li>
            </ol>

            <h3 class="vhm-content__header" v-if="isBuddy||isAh">
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/44000439846" target="_blank">Advanced & Buddy
                    Toolkit Guides</a>
            </h3>
            <ol class="vhm-content__list" v-if="isBuddy||isAh">
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/a/solutions/articles/44002092532" target="_blank">Buddy Guide</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649735"
                   target="_blank">My Circle</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649757"
                   target="_blank">My Wiki</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649754"
                   target="_blank">My Diary</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000649736"
                   target="_blank">My {{ $customTerm("Goals") }}</a></span>
                </li>
            </ol>

            <h3 class="vhm-content__header" v-if="isAh">
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/44000445439" target="_blank">Portal Admin
                    Guides</a></h3>
            <ol class="vhm-content__list" v-if="isAh">
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000657996" target="_blank">Creating and managing accounts &amp; roles in your Portal</a></span>
                </li>
                <li><span class="vhm-content__list-item">
                <i class="fa fa-link" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/solutions/folders/44000657997" target="_blank">Portal Admins tools &amp; templates</a></span>
                </li>
            </ol>
            <h3 class="vhm-content__header">Ask a question or report an issue</h3>
            <ol class="vhm-content__list">
                <li><span class="vhm-content__list-item">
                <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                <a :tabindex="opened?0:-1" href="https://multime.freshdesk.com/support/tickets/new" target="_blank">Please send us a message and we will respond to you within 24 hours. </a></span>
                </li>
            </ol>
            <h3 class="vhm-content__header">
                <a :tabindex="opened?0:-1" href="https://www.multime.com/contact-us" target="_blank" style="text-decoration: underline">Contact
                    Us</a>
            </h3>
            <h3 class="vhm-content__header">
                <a :tabindex="opened?0:-1" href="https://www.multime.com/our-terms-of-use-policy" target="_blank">Terms of Use</a>
            </h3>
            <h3 class="vhm-content__header">
                <a :tabindex="opened?0:-1" href="https://www.multime.com/our-privacy-policy" target="_blank">Privacy Policy</a>
            </h3>
        </div>
    </div>
</template>

<script>
    import {navigateTo} from '~/spa/navigate';
    import {CurrentUserClass} from "../../shared/CurrentUser";
    import HelpDeskDisplay from './HelpDeskDisplay';

    export default {
        name: "HelpDesk",
        components: {HelpDeskDisplay},
        data() {
            return {
                opened: false,
            };
        },
        computed: {
            isAh() {
                return new CurrentUserClass().is_ah();
            },
            isBuddy() {
                return new CurrentUserClass().is_buddy();
            },
            isRbaScopeAdmin() {
                return new CurrentUserClass().is_rba_scope_admin();
            },
            showAHButton() {
                return false;
            },
            ahLink() {
                return new CurrentUserClass().ah_link();
            },
            rbaLink() {
                return new CurrentUserClass().rba_tables_link();
            },
        },
        methods: {
            followLink(e, link) {
                // modified clicks open a new tab like any other link
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) {
                    return;
                }
                e.preventDefault();
                navigateTo(link);
            },
            helpClick() {
                this.opened = !this.opened;
            },
        }
    };
</script>

<style scoped lang="scss">
  .hpc {
    &__container {
      position: fixed;
      background-color: var(--color-help-panel-bg);
      z-index: 1021;
      overflow: visible !important;

      // row-reverse keeps Help on the right and wraps the menu content onto its own line
      @media all and (max-width: 599px) {
        display: flex;
        flex-flow: row-reverse wrap;
        align-content: flex-start;
        column-gap: 8px;
        box-sizing: border-box;
        padding: 6px 8px;
        height: 58px;
        width: 100%;
        left: 0;
        bottom: 0;
        transition: height ease 0.7s;
        &_opened {
          height: 80%;
        }
      }

      @media all and (min-width: 600px) {
        height: 100%;
        top: 0;
        right: 0;
        width: 12px;
        transition: width ease 0.7s;
        &_opened {
          width: 50%;
        }
      }
    }

    &__help-menu-button {
      font: inherit;
      color: var(--color-help-panel-on);
      background: none;
      border: none;

      // opacity: the global button:hover fade would let the page show through
      &:hover, &:focus {
        color: var(--color-help-panel-on);
        text-decoration: none;
        opacity: 1;
      }

      // two-tone so it shows on both the light page and the blue bar
      &:focus-visible {
        outline: 2px solid var(--color-help-panel-on);
        box-shadow: 0 0 0 4px var(--color-help-panel-focus);
      }

      @media all and (max-width: 599px) {
        flex: 1 1 0;
        min-width: 0;
        height: 46px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 0 4px;
        border: 2px solid var(--color-help-panel-button-border);
        border-radius: 14px;
        cursor: pointer;
      }

      @media all and (max-width: 359px) {
        gap: 4px;
        padding: 0 2px;
      }

      // the 50px icon keeps its size, the box grows with the two-line label; 60×98px at Default,
      // always sticking out 10px less than its width from the 12px bar
      @media all and (min-width: 600px) {
        display: block;
        position: relative;
        height: calc(66px + 2rem);
        width: 3.75rem;
        background-color: var(--color-help-panel-bg);
        right: calc(3.75rem - 10px);
        z-index: 1021;
        cursor: pointer;
        padding: 6px 0 0;
        border-radius: 5px;

        &_help {
          top: 35%;
        }

        &_ah {
          top: 38%;
        }

        &_rba {
          top: 38%;
        }

        &_feedback {
          top: 38%;
        }

        // the offsets are relative, so a third button needs its own step down
        &_ah + &_feedback, &_rba + &_feedback {
          top: 41%;
        }
      }
    }

    &__help-icon {
      height: 50px;
      width: 50px;
      background-size: 50px 50px;
      background-position: center;
      background-repeat: no-repeat;
      background-repeat: no-repeat;
      margin: auto;

      @media all and (max-width: 599px) {
        display: none;
      }

      &_lifesaver {
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20enable-background%3D%22new%200%200%2024%2024%22%20xml%3Aspace%3D%22preserve%22%3E%3Cellipse%20fill%3D%22%23FFFFFF%22%20cx%3D%2212%22%20cy%3D%2212.031%22%20rx%3D%2211.625%22%20ry%3D%2211.656%22%2F%3E%3Cpath%20fill%3D%22%23E6493B%22%20d%3D%22M12%2C1.001c6.075%2C0%2C11%2C4.925%2C11%2C10.999s-4.925%2C10.999-11%2C10.999S1%2C18.074%2C1%2C12S5.925%2C1.001%2C12%2C1.001z%20M12%2C6.5%20c-3.037%2C0-5.5%2C2.462-5.5%2C5.5s2.462%2C5.5%2C5.5%2C5.5s5.5-2.462%2C5.5-5.5S15.038%2C6.5%2C12%2C6.5z%20M12%2C2.146c-1.375%2C0-2.685%2C0.275-3.879%2C0.773%20l1.41%2C3.157c0.76-0.318%2C1.594-0.493%2C2.469-0.493s1.709%2C0.175%2C2.469%2C0.493l1.41-3.157C14.686%2C2.421%2C13.375%2C2.146%2C12%2C2.146z%20M5.583%2C12%20c0-0.875%2C0.175-1.708%2C0.492-2.468L2.919%2C8.121C2.421%2C9.314%2C2.146%2C10.625%2C2.146%2C12s0.275%2C2.686%2C0.773%2C3.879l3.156-1.411%20C5.759%2C13.708%2C5.583%2C12.875%2C5.583%2C12z%20M21.854%2C12c0-1.375-0.271-2.686-0.771-3.879l-3.156%2C1.411c0.317%2C0.76%2C0.492%2C1.593%2C0.492%2C2.468%20s-0.175%2C1.708-0.492%2C2.468l3.156%2C1.411C21.58%2C14.686%2C21.854%2C13.375%2C21.854%2C12z%20M12%2C21.854c1.375%2C0%2C2.686-0.272%2C3.879-0.771%20l-1.41-3.157c-0.76%2C0.318-1.594%2C0.492-2.469%2C0.492s-1.709-0.174-2.469-0.492l-1.41%2C3.157C9.315%2C21.579%2C10.625%2C21.854%2C12%2C21.854z%22%2F%3E%3C%2Fsvg%3E");
      }

      &_ah {
        background-image: url('./ah_1.png');
      }

      &_rba {
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M2.5%2C3h19C21.776%2C3%2C22%2C3.224%2C22%2C3.5v17c0%2C0.276-0.224%2C0.5-0.5%2C0.5h-19C2.224%2C21%2C2%2C20.776%2C2%2C20.5v-17C2%2C3.224%2C2.224%2C3%2C2.5%2C3z%20M4%2C5v3h5.5V5H4z%20M11.5%2C5v3H20V5H11.5z%20M4%2C10v3h5.5v-3H4z%20M11.5%2C10v3H20v-3H11.5z%20M4%2C15v4h5.5v-4H4z%20M11.5%2C15v4H20v-4H11.5z%22%2F%3E%3C%2Fsvg%3E");
        background-size: 42px 42px;
      }

      &_feedback {
        position: relative;
        color: var(--color-help-panel-on);
        // stylelint-disable-next-line declaration-property-unit-disallowed-list -- icon sized with its box
        font-size: 22px;

        .fa-thumbs-up {
          position: absolute;
          top: 3px;
          left: 4px;
        }

        .fa-thumbs-down {
          position: absolute;
          bottom: 3px;
          right: 4px;
        }
      }
    }

    &__mobile-icon {
      flex: none;
      width: 28px;
      height: 28px;
      fill: none;
      stroke: var(--color-help-panel-on);
      stroke-width: 1.6px;
      stroke-linecap: round;
      stroke-linejoin: round;

      * {
        vector-effect: non-scaling-stroke;
      }

      @media all and (min-width: 600px) {
        display: none;
      }

      @media all and (max-width: 359px) {
        width: 22px;
        height: 22px;
      }
    }

    &__help-icon-text {
      @media all and (min-width: 600px) {
        text-align: center;
        color: var(--color-help-panel-on);
        font-size: 0.9375rem;
        font-weight: bolder;
        line-height: 1rem;
      }

      @media all and (max-width: 599px) {
        color: var(--color-help-panel-on);
        font-size: 0.9375rem;
        font-weight: bolder;
        line-height: 1rem;
        white-space: nowrap;
      }

      @media all and (max-width: 359px) {
        font-size: 0.8125rem;
      }

      // "Feedback" is one long word, wider than the 60px button at 15px
      &_feedback {
        @media all and (min-width: 600px) {
          font-size: 0.8125rem;
        }
      }
    }

    &__help-icon-text-more {
      @media all and (max-width: 599px) {
        display: none;
      }
    }
  }

  // black on the black page in high contrast, so the bar and its tabs get an outline
  :root[data-theme="high-contrast"] {
    .hpc__container {
      @media all and (max-width: 599px) {
        border-top: 2px solid var(--color-panel-outline);
      }

      @media all and (min-width: 600px) {
        border-left: 2px solid var(--color-panel-outline);
      }
    }

    // ends on the bar's line rather than inside the bar, open where it joins it
    .hpc__help-menu-button {
      @media all and (min-width: 600px) {
        right: 3.75rem;
        border: 2px solid var(--color-panel-outline);
        border-right: 0;
        border-radius: 5px 0 0 5px;
      }
    }
  }

  // from Large up a one-line label no longer fits beside the icon on a phone, so it breaks
  // onto two lines as on desktop, and the bar grows to hold them
  :root[data-text-size="large"], :root[data-text-size="larger"] {
    @media all and (max-width: 599px) {
      .hpc__container:not(.hpc__container_opened) {
        height: calc(20px + 2rem);
      }

      .hpc__help-menu-button {
        height: calc(8px + 2rem);
      }

      .hpc__help-icon-text-more {
        display: inline;
      }
    }
  }

  .vhm-content {
    @media (max-width: 599px) {
      &__container {
        opacity: 0;
        transition-property: opacity;
        transition-duration: 0.3s;
        transition-delay: 0;

        &_opened {
          opacity: 1;
          transition-delay: 0.7s;
        }

        padding-left: 5px;
        max-height: 85%;
        overflow-y: auto;
        width: 100%;

        color: var(--color-help-panel-on);
        margin-top: 25px;

        a {
          color: var(--color-help-panel-on);
        }

        li {
          margin-bottom: 6px;
        }

      }


      &__list {
        max-height: 35vh;
        overflow: auto;
        padding-left: 40px;
      }

      &__list-item {
        font-size: 1rem;
        line-height: 1rem;
      }

      &__header {
        margin-top: 5px;
        font-size: 1.1875rem;

        a {
          text-decoration: underline;
        }
      }
    }

    @media (min-width: 600px) {
      &__container {
        opacity: 0;
        transition-property: opacity;
        transition-duration: 0.3s;
        transition-delay: 0;

        &_opened {
          opacity: 1;
          transition-delay: 0.7s;
        }

        padding-left: 5px;
        max-height: 95%;
        width: 100%;
        overflow-y: auto;
        position: absolute;
        top: 5%;

        ol {
          padding-left: 40px;
        }

        color: var(--color-help-panel-on);
        margin-left: 25px;

        a {
          color: var(--color-help-panel-on);
        }

        li {
          margin-bottom: 5px;
        }
      }

      &__list-item {
        font-size: 1.4375rem;
      }

      &__header {
        margin-top: 10px;
        font-size: 1.5rem;

        a {
          text-decoration: underline;
        }
      }
    }

  }
</style>
